import { Component } from 'react';
import PropTypes from 'prop-types';

class LabelHasRiskClassReductionTextComponent extends Component {
  render() {
    let riskClassReductionTekst = null;
    if (this.props.selectedLabelHasAutoRiskClassReduction) {
      riskClassReductionTekst = (<span className="providertext bold">Dit product biedt u </span>);
    }
    return riskClassReductionTekst;
  }
}

LabelHasRiskClassReductionTextComponent.propTypes = {
  selectedLabelHasAutoRiskClassReduction: PropTypes.bool,
};

LabelHasRiskClassReductionTextComponent.defaultProps = {
  selectedLabelHasAutoRiskClassReduction: false,
};

export default LabelHasRiskClassReductionTextComponent;
